window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-obfuscated-link').forEach((link) => {
    link.addEventListener('click', () => {
      const path = window.atob(link.getAttribute('data-o'));
      const target = link.getAttribute('target');
      const noOpener = link.getAttribute('rel') && link.getAttribute('rel') === 'noopener';
      const myWindow = window.open(path, target || '_self');

      if (noOpener) myWindow.opener = null;
    });
  });
});
